// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_47-0";
export var orangeButton = "_47-1";